import { ActivatedRoute, CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import utils from '../shared/utils';

@Injectable()
export class ClosedCartGuard implements CanActivate {
	constructor(public router: Router, public route: ActivatedRoute) { }

	canActivate(): boolean {
		const { notAvailable = false } = utils.isMaintenance();
		if (notAvailable) {
			this.router.navigate(['/home'], { queryParams: { closedCart: notAvailable } });
			return false;
		}
		return true;
	}
}
